// extracted by mini-css-extract-plugin
export default {"icon":"AddWidgetTemplate_icon__H-Yzn","loading-value":"AddWidgetTemplate_loading-value__d2bNg"};